import { IonContent, IonList, IonItem, IonToggle, IonSelect, IonSelectOption } from "@ionic/react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../data/store";
import { setDarkModeAndStorage } from "../../data/slices/user";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

interface MainPopoverMenuProps {
  dismiss: () => void,
}

// Drei Punkte Menü
const MainPopoverMenu: React.FC<MainPopoverMenuProps> = ({ dismiss }) => {
  const darkMode: boolean = useSelector((state: RootState) => state.user.darkMode)
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  const toggleTheme = (isDark: boolean) => {
    dispatch(setDarkModeAndStorage(isDark))
    document.documentElement.classList.toggle('ion-palette-dark', isDark);
  }

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng); // i18next speichert die Sprache automatisch in localStorage
  };

  return (
    <IonContent>
      <IonList>
        {/* {isLoggedIn ?
    <IonItem button={true} detail={false} onClick={(e) => {
      e.preventDefault();
      dispatch(logout());
      dismiss();
      history.push('/login')
    }}>
      <IonLabel>Logout</IonLabel>
    </IonItem>
    :
    <IonItem button={true} detail={false} onClick={(e) => {
      e.preventDefault();
      dismiss();
      history.push('/login')
    }}>
      <IonLabel>Login</IonLabel>
    </IonItem>
  } */}
        <IonItem button={true} onClick={(e) => {
          e.preventDefault();
          dismiss();
          history.push('start/imprint')
        }}>{t("Impressum")}</IonItem>
        <IonItem button={true} onClick={(e) => {
          e.preventDefault();
          dismiss();
          history.push('start/privacy')
        }}>{t("Datenschutz")}</IonItem>
        <IonItem button={true} detail={false}>
          <IonToggle checked={darkMode} onIonChange={e => toggleTheme(e.detail.checked)}>{t("DarkMode")}</IonToggle>
        </IonItem>
        <IonItem>
          <IonSelect cancelText={t("Abbrechen")} label={t("Sprache")} value={i18n.language} onIonChange={e => changeLanguage(e.detail.value)}>
            <IonSelectOption value="de">{t("Deutsch")}</IonSelectOption>
            <IonSelectOption value="en">{t("Englisch")}</IonSelectOption>
          </IonSelect>
        </IonItem>
      </IonList>
    </IonContent>
  )
};

export default MainPopoverMenu;